import { render, staticRenderFns } from "./SwiperOrders.vue?vue&type=template&id=8b864cf6&scoped=true"
import script from "./SwiperOrders.vue?vue&type=script&lang=js"
export * from "./SwiperOrders.vue?vue&type=script&lang=js"
import style0 from "./SwiperOrders.vue?vue&type=style&index=0&id=8b864cf6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b864cf6",
  null
  
)

export default component.exports